import { render, staticRenderFns } from "./BreadcrumbsNote.vue?vue&type=template&id=17e04bfc"
import script from "./BreadcrumbsNote.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsNote.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbsNote.vue?vue&type=style&index=0&id=17e04bfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports